import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const ContactCandidateModalLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "ContactCandidateModal" */
      './ContactCandidateModal'
    ),
  loading: LoadingModal,
});
